import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getTestId, isValidObject, tokens, useBreakpoint } from '@airtel/air-design-system';
import { useState } from 'react';
import { View } from 'react-native';
import { CarouselWidgetComponent as CarouselWidget } from '../carousel-widget/CarouselWidget';
import { generateBreakpoints, getDefaultAspectRatio, getGrowthInventoryWidgetStyles } from './GrowthInventoryWidgetStyles';
import { InventoryListItem } from './components';
import { SectionTitleWidgetComponent } from '../section-title-widget/SectionTitleWidget';
export var GrowthInventoryWidgetComponent = props => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
  var id = props.id,
    _props$listData = props.listData,
    listData = _props$listData === void 0 ? [] : _props$listData,
    style = props.style,
    carouselWidgetProps = props.carouselWidgetProps,
    cardSectionTitleProps = props.cardSectionTitleProps,
    onUserAction = props.onUserAction,
    onCardVisibleMetaData = props.onCardVisibleMetaData,
    _props$type = props.type,
    type = _props$type === void 0 ? 'list' : _props$type,
    _props$size = props.size,
    size = _props$size === void 0 ? 'md' : _props$size,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'GrowthInventoryListWidgetContainer' : _props$testID;
  var _useState = useState(0),
    currIndex = _useState[0],
    setCurrIndex = _useState[1];
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var breakPoints = generateBreakpoints(type) || {};
  var defaultAspectRatio = getDefaultAspectRatio(type, size);
  var widgetStyles = getGrowthInventoryWidgetStyles(props);
  var inventoryList = (_a = listData === null || listData === void 0 ? void 0 : listData.map((data, id) => {
    var _a;
    return _jsx(View, Object.assign({
      style: widgetStyles.cardContainerOuter
    }, {
      children: _jsx(InventoryListItem, Object.assign({}, data, props, ((props === null || props === void 0 ? void 0 : props.aspectRatio) == null || (props === null || props === void 0 ? void 0 : props.aspectRatio) === 0) && {
        aspectRatio: defaultAspectRatio
      }, {
        onUserAction: onUserAction,
        id: (_a = data.id) !== null && _a !== void 0 ? _a : 'inventory_' + id,
        index: id
      }, getTestId(testID, 'inventory_' + id)), 'inventory_' + id)
    }), 'inventory_' + id);
  })) !== null && _a !== void 0 ? _a : [];
  var onSlideChange = index => {
    setCurrIndex(index);
  };
  var onSlideVisibleHandler = data => {
    onCardVisibleMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onCardVisibleMetaData), Object.assign({
      index: data === null || data === void 0 ? void 0 : data.index
    }, listData === null || listData === void 0 ? void 0 : listData[data === null || data === void 0 ? void 0 : data.index])));
  };
  var _useBreakpoint2 = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint2.isLargeScreen;
  var spacing = {};
  if (cardSectionTitleProps === null || cardSectionTitleProps === void 0 ? void 0 : cardSectionTitleProps.showSpacer) {
    spacing = {
      marginTop: (_b = tokens.spacing) === null || _b === void 0 ? void 0 : _b[isLargeScreen ? (_d = (_c = cardSectionTitleProps === null || cardSectionTitleProps === void 0 ? void 0 : cardSectionTitleProps.spacerProps) === null || _c === void 0 ? void 0 : _c.top) === null || _d === void 0 ? void 0 : _d.desktop : (_f = (_e = cardSectionTitleProps === null || cardSectionTitleProps === void 0 ? void 0 : cardSectionTitleProps.spacerProps) === null || _e === void 0 ? void 0 : _e.top) === null || _f === void 0 ? void 0 : _f.mobile],
      marginRight: (_g = tokens.spacing) === null || _g === void 0 ? void 0 : _g[isLargeScreen ? (_j = (_h = cardSectionTitleProps === null || cardSectionTitleProps === void 0 ? void 0 : cardSectionTitleProps.spacerProps) === null || _h === void 0 ? void 0 : _h.right) === null || _j === void 0 ? void 0 : _j.desktop : (_l = (_k = cardSectionTitleProps === null || cardSectionTitleProps === void 0 ? void 0 : cardSectionTitleProps.spacerProps) === null || _k === void 0 ? void 0 : _k.right) === null || _l === void 0 ? void 0 : _l.mobile],
      marginBottom: (_m = tokens.spacing) === null || _m === void 0 ? void 0 : _m[isLargeScreen ? (_p = (_o = cardSectionTitleProps === null || cardSectionTitleProps === void 0 ? void 0 : cardSectionTitleProps.spacerProps) === null || _o === void 0 ? void 0 : _o.bottom) === null || _p === void 0 ? void 0 : _p.desktop : (_r = (_q = cardSectionTitleProps === null || cardSectionTitleProps === void 0 ? void 0 : cardSectionTitleProps.spacerProps) === null || _q === void 0 ? void 0 : _q.bottom) === null || _r === void 0 ? void 0 : _r.mobile],
      marginLeft: (_s = tokens.spacing) === null || _s === void 0 ? void 0 : _s[isLargeScreen ? (_u = (_t = cardSectionTitleProps === null || cardSectionTitleProps === void 0 ? void 0 : cardSectionTitleProps.spacerProps) === null || _t === void 0 ? void 0 : _t.left) === null || _u === void 0 ? void 0 : _u.desktop : (_w = (_v = cardSectionTitleProps === null || cardSectionTitleProps === void 0 ? void 0 : cardSectionTitleProps.spacerProps) === null || _v === void 0 ? void 0 : _v.left) === null || _w === void 0 ? void 0 : _w.mobile]
    };
  }
  return _jsx(_Fragment, {
    children: !!(listData === null || listData === void 0 ? void 0 : listData.length) && _jsxs(View, Object.assign({
      style: [widgetStyles.cardContainer, style]
    }, {
      children: [!!isValidObject(cardSectionTitleProps) && _jsx(View, Object.assign({
        style: spacing
      }, getTestId(testID, 'withSpacer'), {
        children: _jsx(SectionTitleWidgetComponent, Object.assign({
          style: [widgetStyles.sectionTital, cardSectionTitleProps.style],
          actionTypes: isSmallScreen ? 'carousel-indicator' : 'none',
          onUserAction: onUserAction,
          carouselIndicatorProps: {
            currIndex: currIndex,
            dataLength: isSmallScreen ? inventoryList === null || inventoryList === void 0 ? void 0 : inventoryList.length : 0
          }
        }, cardSectionTitleProps, getTestId(testID, 'section')))
      })), _jsx(CarouselWidget, Object.assign({
        data: inventoryList,
        carouselType: "COMPONENT",
        navigationCtaPosition: "relative",
        showNavigationCounterWithButton: isSmallScreen ? false : true,
        alignment: "center",
        onSlideChangeHandler: onSlideChange,
        onSlideVisibleHandler: onSlideVisibleHandler,
        onUserAction: onUserAction,
        breakPoints: breakPoints
      }, carouselWidgetProps, getTestId(testID, 'carousel')))]
    }))
  });
};
GrowthInventoryWidgetComponent.genericRendererKey = 'AirGrowthInventoryWidget';